import { render, staticRenderFns } from "./StreamingTheSports.vue?vue&type=template&id=12558cb3&scoped=true"
import script from "./StreamingTheSports.vue?vue&type=script&lang=js"
export * from "./StreamingTheSports.vue?vue&type=script&lang=js"
import style0 from "./StreamingTheSports.vue?vue&type=style&index=0&id=12558cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12558cb3",
  null
  
)

export default component.exports